// extracted by mini-css-extract-plugin
export default {"statusChip":"PolicyStatusPill_statusChip__vowMc","cancelled":"PolicyStatusPill_cancelled__Mp0EB","active":"PolicyStatusPill_active__7xLek","future":"PolicyStatusPill_future__5lMfF"};